module.exports = __webpack_public_path__ + "static/media/2. Punzada, Mixta en tela, 80 x 180 cm, 2019 copy.eeb17121.png";